import { addCyPrefixToIDs } from 'moet-test-utils/cypress/utils';

const cyPrefix = 'address_form_component';

const ids = addCyPrefixToIDs(cyPrefix, {
  INPUT_POSTAL_CODE: 'INPUT_POSTAL_CODE',
  INPUT_CITY: 'INPUT_CITY',
  INPUT_STREET: 'INPUT_STREET',
  INPUT_COUNTRY: 'INPUT_COUNTRY',
  INPUT_REGION: 'INPUT_REGION',
});

/**
 * We are exporting the IDS this way to help IDEs' code completion
 */
export const CY_ADDRESS_FORM_COMPONENT_IDS = ids;

export const tPrefix = 'products-fe.address_form_component';
